var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 28,
    viewBox: "0 0 31 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2872 4.14666C26.6061 3.46533 25.7976 2.92485 24.9076 2.5561C24.0177 2.18735 23.0638 1.99756 22.1005 1.99756C21.1372 1.99756 20.1833 2.18735 19.2933 2.5561C18.4034 2.92485 17.5948 3.46533 16.9138 4.14666L15.5005 5.55999L14.0872 4.14666C12.7116 2.77107 10.8459 1.99827 8.90048 1.99827C6.95511 1.99827 5.08941 2.77107 3.71382 4.14666C2.33823 5.52225 1.56543 7.38795 1.56543 9.33333C1.56543 11.2787 2.33823 13.1444 3.71382 14.52L5.12715 15.9333L15.5005 26.3067L25.8738 15.9333L27.2872 14.52C27.9685 13.839 28.509 13.0304 28.8777 12.1405C29.2465 11.2505 29.4363 10.2966 29.4363 9.33333C29.4363 8.37001 29.2465 7.41613 28.8777 6.52619C28.509 5.63624 27.9685 4.82767 27.2872 4.14666V4.14666Z",
    stroke: "#767676",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.b2c2a368d74f96ab5514c2fd66fc45cf.svg";
export { ForwardRef as ReactComponent };